import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import FormikForm from './form/Formik';
import FormData from './formData.json';
import { FormEntityProps } from '@shared/types';
import { getRootId } from '@shared/utils';

const { data, rootIdName } = getRootId(FormData as FormEntityProps);

// Renders the form layout in the React root div with a dynamic or default root div id.
// Passes form data from formData.json to Layout App.
const rootEl = document.getElementById(rootIdName);
if (!rootEl) {
  throw new Error(`Root element with id "${rootIdName}" not found`);
}
const root = ReactDOM.createRoot(rootEl);
root.render(
  <React.StrictMode>
    <FormikForm {...data} />
  </React.StrictMode>,
);
